import React from 'react'

import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    backgroundColor: 'black',
    backgroundImage: `url('/404.png')`,
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: '100vh',
    width: '100vw',
  },
})

export default function PageNotFound() {
  const styles = useStyles()
  return <div className={styles.root} />
}
